import { Page } from "@/components/page";
import { Flex, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { GenerateGameCard } from "./-components/generate-game-card";
import { ExploreGamesCard } from "./-components/explore-games-card";
import { ExploreGameGeneratorsCard } from "./-components/explore-game-generators-card";
import { SettingsCard } from "./-components/settings-card";
import { ExploreScriptsCard } from "./-components/explore-scripts-card";

export const Route = createFileRoute("/_authenticated/_subscribed/_main/home/")(
  {
    component: HomeRouteComponent,
  },
);

export function HomeRouteComponent() {
  return (
    <Page title="Home">
      <Title mb="xl">Home</Title>
      <Flex wrap="wrap" gap="lg">
        <GenerateGameCard />
        <ExploreGameGeneratorsCard />
        <ExploreGamesCard />
        <ExploreScriptsCard />
        <SettingsCard />
      </Flex>
    </Page>
  );
}
